import { useMutation, useQuery } from '@tanstack/react-query'

import type { UseQueryResult, UseMutationResult } from '@tanstack/react-query'
import type { DeviceType } from '~/types/device-type'
import type { IExternalLink } from '~/types/external-links'

import {
  createAppExternalLink,
  deleteAppExternalLink,
  getAppExternalLinks,
  updateAppExternalLink,
} from '~/api/external-links'

////////// KEYS //////////

export const keys = {
  all: ['external-links'] as const,
  list: (appKey: string, deviceType: DeviceType) => [...keys.all, 'list', appKey, deviceType] as const,
}

////////// QUERIES //////////
export const useExternalLinksListQuery = (
  appKey: string,
  deviceType: DeviceType
): UseQueryResult<IExternalLink[], unknown> => {
  return useQuery({
    queryFn: () => getAppExternalLinks({ appKey, deviceType }),
    queryKey: keys.list(appKey, deviceType),
  })
}

////////// MUTATIONS //////////

export const useCreateAppExternalLinkMutation = (): UseMutationResult<
  void,
  unknown,
  { appKey: string; deviceType: DeviceType; target: string; url: string },
  unknown
> => useMutation({ mutationFn: createAppExternalLink })

export const useUpdateAppExternalLinkMutation = (): UseMutationResult<
  void,
  unknown,
  { appKey: string; deviceType: DeviceType; externalLinkID: string; target: string; url: string },
  unknown
> => useMutation({ mutationFn: updateAppExternalLink })

export const useDeleteExternalLinkMutation = (): UseMutationResult<
  void,
  unknown,
  {
    appKey: string
    deviceType: DeviceType
    externalLinkID: string
  },
  unknown
> => useMutation({ mutationFn: deleteAppExternalLink })
